import { formatPrice } from "helpers";
import { JalaliToMiladi } from "helpers/dataFormat";
import { toWords } from "number-to-words";
import { useRef } from "react";
import { useSelector } from "react-redux";

const useForeignFactorPrint = (props: { factor?: Factor, remittance?: Remmitance }) => {
    const store = useSelector((state: any) => state);
    const { remittance } = props
    const factor: Factor = props?.factor || store.factorReducer?.factor;
    const contentRef = useRef<any>(null);
    const getFactorDate = () => {
        const date = factor.dueDate.split('/')
        const newDate = JalaliToMiladi(parseInt(date[0]), parseInt(date[1]), parseInt(date[2]))
        return `${newDate[0]}/${newDate[1] < 10 ? '0' + newDate[1] : newDate[1]}/${newDate[2] < 10 ? '0' + newDate[2] : newDate[2]}`
    }
    let content = <></>;
    if (factor) {
        content = (
            <div ref={contentRef}
                className="container mx-auto foreignFont text-sm " style={{ direction: "ltr" }}>
                <h1 className="foreignFont text-2xl font-bold text-center mb-4">Sales Order</h1>
                <div className="foreignFont flex justify-between mb-4">
                    <div className="foreignFont border w-1/2">
                        <div className="foreignFont flex">
                            <p className=" text-sm foreignFont font-bold">Cust. Id:</p>
                            <p className=" text-sm foreignFont">{factor.Person.id}</p>

                        </div>
                        <div className="foreignFont flex">
                            <p className=" text-sm foreignFont font-bold">Contac Name:</p>
                            <p className=" text-sm foreignFont">{factor.Person.nickName}</p>

                        </div>
                        <div className="foreignFont flex gap-10 flex-nowrap">
                            <div className="foreignFont flex">
                                <p className=" text-sm foreignFont font-bold">Tel:</p>
                                <p className=" text-sm foreignFont">{factor.Person.mobile}</p>

                            </div>
                            <div className="foreignFont flex">
                                <p className=" text-sm foreignFont font-bold">Fax:</p>
                                <p className=" text-sm foreignFont">{factor.Person.phone}</p>

                            </div>

                        </div>
                    </div>
                    <div className="foreignFont w-1/4 text-left flex items-start flex-col">
                        <div className="foreignFont flex items-start">
                            <p className=" text-sm foreignFont font-bold">Inv. #:</p>
                            <p className=" text-sm foreignFont">{remittance?.id}</p>

                        </div>
                        <div className="foreignFont flex items-start">
                            <p className=" text-sm foreignFont font-bold">Date:</p>
                            <p className=" text-sm foreignFont">{getFactorDate()}</p>
                        </div>
                        <div className="flex items-start">
                            {/* <p className="foreignFont font-bold">LPO:</p> */}

                        </div>
                    </div>
                </div>
                <table className="w-full text-center table-auto border-collapse border border-gray-300">
                    <thead>
                        <tr>
                            <th className="foreignFont text-xs font-bold w-8  py-1 border border-gray-300">Sl. #</th>
                            <th className="foreignFont text-xs font-bold w-28 py-1 border border-gray-300">Item Code</th>
                            <th className="foreignFont text-xs font-bold  py-1 border border-gray-300">Description</th>
                            <th className="foreignFont text-xs font-bold  py-1 border border-gray-300">Unit</th>
                            <th className="foreignFont text-xs font-bold  py-1 border border-gray-300">Quantity</th>
                            <th className="foreignFont text-xs font-bold  py-1 border border-gray-300">Price/Unit</th>
                            <th className="foreignFont text-xs font-bold  py-1 border border-gray-300">Line Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            factor.Factor_Items?.map((row, index) => (
                                <tr key={row.id + index} className="whitespace-normal h-9">
                                    <td className="foreignFont text-xs text-right w-8    py-1 border-l border-r border-gray-300 ">{index + 1}</td>
                                    <td className="foreignFont text-xs text-left w-28 py-1 border-l border-r border-gray-300">{row.Product.accountingCode}</td>
                                    <td className="foreignFont text-xs text-left   py-1 border-l border-r border-gray-300">{row.Product.title}</td>
                                    <td className="foreignFont text-xs text-center   py-1 border-l border-r border-gray-300">{row.Product.unit}</td>
                                    <td className="foreignFont text-xs text-right  py-1 border-l border-r border-gray-300">{formatPrice(row.quantity)}</td>
                                    <td className="foreignFont text-xs text-right  py-1 border-l border-r border-gray-300">{formatPrice(row.price)}  </td>
                                    <td className="foreignFont text-xs text-right  py-1 border-l border-r border-gray-300">{formatPrice(row.totalOneProduct)}  </td>
                                </tr>
                            ))
                        }
                        <tr>
                            <td className="foreignFont text-xs     py-1 border-l border-r border-gray-300 "></td>
                            <td className="foreignFont text-xs   px-2 py-1 border-l border-r border-gray-300"></td>
                            <td className="foreignFont text-xs   px-2 py-1 border-l border-r border-gray-300"></td>
                            <td className="foreignFont text-xs   py-1 border-l border-r border-gray-300"></td>
                            <td className="foreignFont text-xs   px-2 py-1 border-l border-r border-gray-300"></td>
                            <td className="foreignFont text-xs   px-2 py-1 border-l border-r border-gray-300"> </td>
                            <td className="foreignFont text-xs   px-2 py-1 border-l border-r border-gray-300"> </td>
                        </tr>
                    </tbody>
                </table>
                <div className="flex flex-row foreignFont text-xs items-start border-b">
                    <div className="flex foreignFont text-xs justify-between w-3/4 mr-6 ">

                        <p className="foreignFont text-xs font-bold text-left ">
                            {toWords(factor.total)}

                        </p>

                    </div>
                    <div className="flex  flex-col w-1/3">

                        <div className="flex gap-11">
                            <p className="foreignFont text-xs font-bold">Total: </p>
                            <p className="foreignFont text-xs font-bold min-w-8">
                                {formatPrice(factor.total)}

                            </p>
                            <p>{factor.Currency.en_title}</p>

                        </div>
                        <div className="flex gap-7">
                            <p className="foreignFont text-xs font-bold">Discount:</p>
                            <p className="foreignFont text-xs font-bold min-w-10">{formatPrice(factor.totalDiscount)}    </p>
                            <p>{factor.Currency.en_title}</p>

                        </div >
                        <div className="flex gap-7 text-nowrap">
                            <p className="font-bold foreignFont text-xs">Net Total:</p>
                            <p className="foreignFont text-xs font-bold min-w-10">{formatPrice(factor.totalPrice)}  </p>
                            <p>{factor.Currency.en_title}</p>
                        </div>
                    </div>
                </div>
                <div className="mt-4 flex justify-between foreignFont text-xs ">
                    <p className="foreignFont text-xs">Received by:</p>
                    <p className="foreignFont text-xs">Approved by:</p>
                    <p className="foreignFont text-xs">Prepared by:</p>
                </div>
            </div>)
    }
    return { content, contentRef };
}

export default useForeignFactorPrint;